<template>
  <div>
    <a
      class="btn btn-primary"
      href="/admin/vacation"
    >Back</a>

    <div><h4>Year: {{ year }}</h4></div>

    <div class="card my-3">
      <div class="card-header bg-primary-light">
        <div class="d-flex justify-content-between align-items-center">
          <div class="card-title mb-0">
            <h3 class="mb-0">
              Holiday Work Requests{{ staff?.user?.full_name ? " - " + staff.user.full_name : "" }}
            </h3>
          </div>
          <staff-holiday-work-request-button
            v-if="isViewingOwnList"
            :staff-id="staffId"
            :year="year"
            @update-table="fetchList"
          />
        </div>
      </div>
      <div class="card-body">
        <div v-if="isLoading" class="text-center py-4">
          <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
          <span class="ms-2">Loading...</span>
        </div>
        <holiday-work-list-table
          v-else
          :staff-id="staffId"
          :holiday-work-list="holidayWorkList"
          :year="year"
          :is-manager="isManager"
          :read-only="!isViewingOwnList"
          :is-super-admin="isSuperAdmin"
          @get-list="fetchList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HolidayWorkListTable from "./elements/HolidayWorkListTable.vue";
import StaffHolidayWorkRequestButton from "./StaffHolidayWorkRequestButton.vue";

export default {
    name: "StaffHolidayWorkList",
    components: { HolidayWorkListTable, StaffHolidayWorkRequestButton },
    props: {
        staffId: {
            type: Number,
            required: true,
        },
        year: {
            type: Number,
            required: true,
        },
        currentStaffId: {
            type: Number,
            required: true,
        },
        leaveType: {
            type: String,
            required: false,
            default: "holiday_work",
        },
        isSuperAdmin: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isLoading: true,
        };
    },
    computed: {
        ...mapGetters({
            holidayWorkList: "vacation/holidayWorkList",
        }),
        isManager() {
            return this.isSuperAdmin;
        },
        isViewingOwnList() {
            return this.staffId === this.currentStaffId;
        },
        staff() {
            if (this.holidayWorkList.length === 0) return false;
            return this.holidayWorkList[0].staff;
        },
    },
    mounted() {
        this.fetchList();
    },
    methods: {
        async fetchList() {
            this.isLoading = true;
            try {
                await this.getHolidayWorkRequests({
                    staffId: this.staffId,
                    year: this.year,
                });
            } finally {
                this.isLoading = false;
            }
        },
        ...mapActions({
            getHolidayWorkRequests: "vacation/getHolidayWorkRequests",
        }),
    },
};
</script>
